import type { BadgeTone } from '@wundo/ui';
import type { InsightRunStatus } from '@/lib/insights.ts';

/** The Vue console's colours, in the semantic tones that replaced them. */
export const RUN_STATUS_TONE: Record<InsightRunStatus, BadgeTone> = {
  pending: 'warning',
  running: 'info',
  finished: 'success',
  failed: 'danger',
  cancelled: 'neutral',
};

/** A run that has not settled yet: the page keeps asking while one is. */
export function isRunActive(status: InsightRunStatus | undefined): boolean {
  return status === 'pending' || status === 'running';
}

/**
 * How long a run took, in the coarsest unit that still says something —
 * seconds under a minute, minutes and seconds above it.
 */
export function runDuration(
  started: string | null,
  finished: string | null,
): string | null {
  if (!started || !finished) return null;

  const seconds = Math.round(
    (new Date(finished).getTime() - new Date(started).getTime()) / 1000,
  );

  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}
